/**
 * Layout — structure principale (sidebar + contenu) pour les routes authentifiées.
 */
import { Outlet, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { colors } from "../styles/tokens";
import useAuth from "../hooks/useAuth";

export default function Layout() {
  const { isAuthenticated, loading, usingMock } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 900);
    handler();
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (loading) {
    return (
      <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: colors.bg, color: colors.textMuted }}>
        Chargement...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: colors.bg, maxWidth: "100vw", overflowX: "hidden" }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          minWidth: 0,
          padding: isMobile ? "76px 16px 24px" : "32px 40px",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        {usingMock && (
          <div
            style={{
              background: colors.goldDim,
              border: `1px solid ${colors.goldBorder}`,
              color: colors.goldLight,
              padding: "10px 14px",
              borderRadius: "10px",
              fontSize: "13px",
              marginBottom: "20px",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            ⓘ Mode démo — backend indisponible. Toutes les modifications sont locales.
          </div>
        )}
        <Outlet />
      </main>
    </div>
  );
}
